"use strict";
var appn;
(function (appn) {
    var dateFilter;
    (function (dateFilter) {
        function init(dfilter, customFilterCallBack) {
            const state = dfilter ? dfilter : getStateOrDefaultAsString();
            dfilter = state ? state : 'ThisMonth';
            setValueFromString(dfilter);
            addEvents(customFilterCallBack);
        }
        dateFilter.init = init;
        function addEvents(customFilterCallBack) {
            $('.appnDateFilter #customfilter').off().on('click', function (e) {
                e.preventDefault();
                $('#CustomRange').click();
                if (customFilterCallBack)
                    customFilterCallBack();
            });
            $('.appnDateFilter .appnDateFilter-link').off().on('click', function (e) {
                e.preventDefault();
                const appnDateFilter = $('.appnDateFilter');
                appnDateFilter.find('li').removeClass('active');
                $(this).closest('li').addClass('active');
                appn.dataTable.uncheckAllRowsBox();
            });
            $('.appnDateFilter .container-fluid').off().on('click', function (e) {
                e.stopPropagation();
            });
        }
        function getStateOrDefault() {
            const appnDateFilter = $('.appnDateFilter');
            const dateFilterValue = appn.dataTable.getStateOrDefault(appn.saveMeState.getRegisterId(appnDateFilter), getValueAsString()).value;
            const dateFilterValues = getValue(dateFilterValue);
            return dateFilterValues;
        }
        dateFilter.getStateOrDefault = getStateOrDefault;
        function getStateOrDefaultAsString() {
            const appnDateFilter = $('.appnDateFilter');
            return appn.dataTable.getStateOrDefault(appn.saveMeState.getRegisterId(appnDateFilter), getValueAsString()).value;
        }
        dateFilter.getStateOrDefaultAsString = getStateOrDefaultAsString;
        function getValueAsString() {
            const activeValue = getValue();
            if (!activeValue)
                return appn.emptyString;
            return activeValue.type + '|' + activeValue.fromDate + '|' + activeValue.toDate;
        }
        dateFilter.getValueAsString = getValueAsString;
        function getValue(valueString) {
            const url = window.location.href;
            const filterValues = {
                type: url.toLowerCase().contains('TaskTemplates'.toLowerCase()) ? 'All' : 'ThisMonth',
                fromDate: appn.emptyString,
                toDate: appn.emptyString
            };
            if (valueString) {
                const bits = valueString.split('|');
                filterValues.type = bits[0];
                filterValues.fromDate = bits[1];
                filterValues.toDate = bits[2];
                return filterValues;
            }
            const appnDateFilter = $('.appnDateFilter');
            const type = appnDateFilter.find('li.active .appnDateFilter-link').prop('id');
            if (type)
                filterValues.type = type;
            filterValues.fromDate = appnDateFilter.find('#FromDate').val();
            filterValues.toDate = appnDateFilter.find('#ToDate').val();
            return filterValues;
        }
        dateFilter.getValue = getValue;
        function isAtLeastOneActive() {
            return $('.appnDateFilter').find('li').hasClass('active');
        }
        function setValueFromString(value) {
            if (!value)
                return;
            if (isAtLeastOneActive() && getValueAsString() === value)
                return;
            const bits = value.split('|');
            const appnDateFilter = $('.appnDateFilter');
            appnDateFilter.find('li').removeClass('active');
            appnDateFilter.find('#' + bits[0]).closest('li').addClass('active');
            if (bits[1])
                appnDateFilter.find('#FromDate').val(bits[1]);
            if (bits[2])
                appnDateFilter.find('#ToDate').val(bits[2]);
            appn.dataTable.uncheckAllRowsBox();
        }
        dateFilter.setValueFromString = setValueFromString;
        function reset() {
            setValueFromString('ThisMonth');
        }
        dateFilter.reset = reset;
    })(dateFilter = appn.dateFilter || (appn.dateFilter = {}));
})(appn || (appn = {}));
